import { render } from "./SkeletonCard.vue?vue&type=template&id=6e43fb86"
import script from "./SkeletonCard.vue?vue&type=script&lang=js"
export * from "./SkeletonCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__